import React, { useMemo } from 'react';

import '../static/styles/MarkdownRenderer.css';
import { buildGithubAssetUrl } from '../utils/api';

const escapeHtml = (value) => value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

const convertMarkdownToHtml = (markdown, repo) => {
    if (!markdown) {
        return '';
    }

    let text = markdown.replace(/\r\n/g, '\n');

    const codeBlocks = [];
    text = text.replace(/```([\s\S]*?)```/g, (_, code) => {
        const placeholder = `@@CODE_BLOCK_${codeBlocks.length}@@`;
        codeBlocks.push(`<pre><code>${escapeHtml(code.trim())}</code></pre>`);
        return placeholder;
    });

    text = escapeHtml(text);

    for (let level = 6; level >= 1; level -= 1) {
        const pattern = new RegExp(`^${'#'.repeat(level)}\\s+(.*)$`, 'gm');
        text = text.replace(pattern, `<h${level}>$1</h${level}>`);
    }

    text = text.replace(/^&gt;\s?(.*)$/gm, '<blockquote>$1</blockquote>');

    text = text.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, (_, alt, src) => {
        const resolved = buildGithubAssetUrl(repo, src);
        return `<img src="${resolved}" alt="${alt}" />`;
    });

    text = text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noreferrer">$1</a>');

    text = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    text = text.replace(/__(.*?)__/g, '<strong>$1</strong>');
    text = text.replace(/`([^`]+)`/g, '<code>$1</code>');

    text = text.replace(/\n/g, '<br />');

    codeBlocks.forEach((block, index) => {
        text = text.replace(`@@CODE_BLOCK_${index}@@`, block);
    });

    return text;
};

export default function MarkdownRenderer({ content = '', repo }) {
    const html = useMemo(() => convertMarkdownToHtml(content, repo), [content, repo]);

    if (!html) {
        return <p className="markdown-empty">README not available for this repository.</p>;
    }

    return (
        <div
            className="markdown-body"
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
}
